/**
 * Logger Utility for Admin Panel
 *
 * Centralized logging to allow environment-based filtering.
 * In production, debug and info logs can be suppressed or routed to a monitoring service.
 */

// Check if we are in production
const isProduction = import.meta.env.PROD;

// Allow overriding via local storage for debugging in prod
// Set localStorage.setItem('DEBUG_LOGS', 'true') to enable
const isDebugEnabled =
    typeof localStorage !== 'undefined' && localStorage.getItem('DEBUG_LOGS') === 'true';

const shouldLog = (level: 'info' | 'warn' | 'error' | 'debug') => {
    if (isDebugEnabled) return true;
    if (!isProduction) return true;

    // In production, only show warnings and errors by default
    return level === 'warn' || level === 'error';
};

class Logger {
    static log(message: string, ...args: any[]) {
        if (shouldLog('info')) {
            console.log(message, ...args);
        }
    }

    static debug(message: string, ...args: any[]) {
        if (shouldLog('debug')) {
            console.debug(message, ...args);
        }
    }

    static info(message: string, ...args: any[]) {
        if (shouldLog('info')) {
            console.info(message, ...args);
        }
    }

    static warn(message: string, ...args: any[]) {
        if (shouldLog('warn')) {
            console.warn(message, ...args);
        }
    }

    static error(message: string, ...args: any[]) {
        if (shouldLog('error')) {
            console.error(message, ...args);
        }
    }
}

export default Logger;
